<template>
    <div>
        <canvas ref="gradientCanvas" style="display: none"></canvas>
        <component
            :is="chartType"
            :data="chartData"
            :dataset="chartDataset"
            :height="parentHeight"
            :refresh="isUrlData ? refresh : null"
            v-bind="$attrs"
            :key="refreshKey"
        />
    </div>
</template>

<script>
console.log('GradientChart.vue')
import {defineComponent} from 'vue'
import { ColumnChart, LineChart, AreaChart } from 'vue-chartkick'

export default defineComponent({
    name: 'GradientChart',
    components: { ColumnChart, LineChart, AreaChart },
    inheritAttrs: false,
    props: {
        type: {
            type: String,
            default: 'column',
            // validator: value => ['column', 'line', 'area'].includes(value)
        },
        colors: {
            type: Array,
            default: () => []
        },
        data: {
            type: [Array, Object, String],  // Allow string for URL data
            required: true
        },
        options: {
            type: Object,
            default: () => ({})
        },
        dataUrl: {
            type: String,
            default: ''
        },
        refresh: {
            type: [Number, String],
            default: null  // Only pass to Chartkick when explicitly set
        }
    },
    computed: {
        chartType() {
            const types = {
                column: 'column-chart',
                line: 'line-chart',
                area: 'area-chart'
            }
            return types[this.type]
        },
        chartDataset() {
            return {
                borderWidth: 0,
                backgroundColor: this.gradient,
                borderRadius: 10,
                ...this.options.dataset
            }
        },
        // Check if data is a URL string (for Chartkick's built-in fetching)
        isUrlData() {
            return typeof this.data === 'string' && this.data.startsWith('/')
        }
    },
    data() {
        return {
            gradient: null,
            chartData: this.data,
            refreshKey: 0
        }
    },
    mounted() {
        this.createGradient();
        // Use dataUrl prop for custom polling (separate from Chartkick's refresh)
        if (this.dataUrl) {
            this.fetchChartData();
            const interval = typeof this.refresh === 'number' ? this.refresh * 1000 : 10000;
            this.pollTimer = setInterval(this.fetchChartData, interval);
        }
    },
    unmounted() {
        if (this.pollTimer) {
           clearInterval(this.pollTimer);
        }
    },
    methods: {
        fetchChartData() {
            if (!this.dataUrl) return;
            axios.get(this.dataUrl)
                 .then(response => {
                     this.chartData = response.data;
                     this.refreshKey++;
                 })
                 .catch(error => {
                     console.error("Error fetching chart data:", error);
                 });
        },
        createGradient() {
            if (this.colors.length > 0) {
                const ctx = this.$refs.gradientCanvas.getContext('2d')
                const gradient = ctx.createLinearGradient(0, 250, 0, 0)

                this.colors.forEach((color, index) => {
                    gradient.addColorStop(index / (this.colors.length - 1), color)
                })

                this.gradient = gradient
            }
        }
    },
    watch: {
        colors: {
            handler() {
                this.createGradient()
            },
            deep: true
        }
    }
})
</script>
